export type Identified<T> = Omit<T, 'id'> & { readonly id: string };

export const isIdentified = <T>(value: unknown): value is Identified<T> =>
  !!value && typeof value === 'object' && 'id' in value && typeof value.id === 'string';

export const isIdentifiedArray = <T>(value: unknown): value is readonly Identified<T>[] => {
  if (!Array.isArray(value)) {
    return false;
  }

  return !value.some((value: any): boolean => !isIdentified(value));
};
